import { useQuery } from '@tanstack/react-query'
import { cpGetAvailablePriceLists } from '@/lib/api/controlPlaneClient'

export function useAvailablePriceLists(enabled: boolean) {
  const query = useQuery({
    queryKey: ['available-price-lists'],
    queryFn: cpGetAvailablePriceLists,
    enabled,
    staleTime: 5 * 60 * 1000, // 5min — price lists rarely change
  })

  return {
    priceLists: query.data ?? [],
    isLoading: query.isLoading,
    isError: query.isError,
  }
}
